import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDsautomobilesComponent } from './simple-icons-dsautomobiles.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDsautomobilesComponent ],
    exports:      [ SimpleIconsDsautomobilesComponent ],
    bootstrap:    []
})
export class SimpleIconsDsautomobilesModule {}
